"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newAnswerAreaPinComponent = void 0;
const geometry_1 = require("../geometry");
const order_1 = require("../order");
const random_id_1 = require("../random-id");
function newAnswerAreaPinComponent({ position = (0, geometry_1.newVector)(32, 124), size = (0, geometry_1.newSize)(896, 384), backgroundColor = '#FFFFFF', transparency, order = order_1.defaultOrder, }) {
    return {
        type: 'ANSWER_AREA',
        id: (0, random_id_1.randomId)(),
        settings: {
            backgroundColor,
            transparency,
            lockLayout: true,
        },
        layout: (0, geometry_1.newBox)(position, size),
        order,
    };
}
exports.newAnswerAreaPinComponent = newAnswerAreaPinComponent;
//# sourceMappingURL=answer-area-pin-component.js.map